import React, { ReactNodeArray, useEffect, useState } from 'react';

import { RankPageViewCount } from '../../../api/serviceAnalytics/pageviewAnalysis/type';
import DataError from '../../Atoms/DataError';
import DefaultPieChart from '../../Molecule/Chart/PieChart';
import {
  TableHead,
  HeadGroupTitle,
  HeadPageViewTitle,
  HeadRateTitle,
  HeadURLTitle,
  TableWrapper,
  TableBodyItem,
  TableBodyURL,
  TableBodyGroup,
  TableBodyGroupItem,
  TableBodyPageView,
  TableBodyPageViewItem,
  TableBodyRate,
  TableBodyWrapper,
  IconFillArrowDown,
  HeadPageViewTitleText,
} from './styled';

interface DefaultTableProps {
  Data: RankPageViewCount[] | null;
  loading: boolean;
}

const PageViewTable = ({ Data, loading }: DefaultTableProps) => {
  const [isAsc, setIsAsc] = useState(false);

  const [ascBody, setAscBody] = useState<ReactNodeArray>([]);
  const [descBody, setDescBody] = useState<ReactNodeArray>([]);

  const printTable = () => {
    const ascResult: ReactNodeArray = [];
    const descResult: ReactNodeArray = [];

    if (Data) {
      Data.some((element, index) => {
        if (index > 9) {
          return true;
        }
        ascResult.push(
          <TableBodyItem key={element.page_referrer + element.total_count}>
            <TableBodyURL>{element.page_referrer}</TableBodyURL>
            <TableBodyGroup>
              <TableBodyGroupItem>전체 사용자</TableBodyGroupItem>
              <TableBodyGroupItem>재방문 사용자</TableBodyGroupItem>
              <TableBodyGroupItem>신규 사용자</TableBodyGroupItem>
            </TableBodyGroup>
            <TableBodyPageView>
              <TableBodyPageViewItem>
                {element.total_count}
              </TableBodyPageViewItem>
              <TableBodyPageViewItem>{element.old_count}</TableBodyPageViewItem>
              <TableBodyPageViewItem>{element.new_count}</TableBodyPageViewItem>
            </TableBodyPageView>
            <TableBodyRate>
              <DefaultPieChart
                data={[
                  { name: '재방문 사용자', value: Number(element.old_rate) },
                  { name: '신규 사용자', value: Number(element.new_rate) },
                ]}
              />
            </TableBodyRate>
          </TableBodyItem>
        );
        return false;
      });
      setAscBody(ascResult);
      Data.reverse().forEach((element, index) => {
        if (index > 9) {
          return true;
        }
        descResult.push(
          <TableBodyItem key={element.page_referrer + element.total_count}>
            <TableBodyURL>{element.page_referrer}</TableBodyURL>
            <TableBodyGroup>
              <TableBodyGroupItem>전체 사용자</TableBodyGroupItem>
              <TableBodyGroupItem>재방문 사용자</TableBodyGroupItem>
              <TableBodyGroupItem>신규 사용자</TableBodyGroupItem>
            </TableBodyGroup>
            <TableBodyPageView>
              <TableBodyPageViewItem>
                {element.total_count}
              </TableBodyPageViewItem>
              <TableBodyPageViewItem>{element.old_count}</TableBodyPageViewItem>
              <TableBodyPageViewItem>{element.new_count}</TableBodyPageViewItem>
            </TableBodyPageView>
            <TableBodyRate>
              <DefaultPieChart
                data={[
                  { name: '재방문 사용자', value: Number(element.old_rate) },
                  { name: '신규 사용자', value: Number(element.new_rate) },
                ]}
              />
            </TableBodyRate>
          </TableBodyItem>
        );
        return false;
      });

      setDescBody(descResult);
    }
  };

  useEffect(() => {
    if (Data) {
      printTable();
    }
  }, [loading]);

  const onClickPV = () => {
    setIsAsc(!isAsc);
  };

  return (
    <div>
      {Data ? (
        <TableWrapper>
          <TableHead>
            <HeadURLTitle>페이지 URL</HeadURLTitle>
            <HeadGroupTitle>사용자 그룹</HeadGroupTitle>
            <HeadPageViewTitle onClick={onClickPV}>
              <HeadPageViewTitleText>페이지 뷰</HeadPageViewTitleText>
              <IconFillArrowDown $isAsc={isAsc} />
            </HeadPageViewTitle>
            <HeadRateTitle>전체 대비 비율</HeadRateTitle>
          </TableHead>
          <TableBodyWrapper>{isAsc ? ascBody : descBody}</TableBodyWrapper>
        </TableWrapper>
      ) : (
        <DataError />
      )}
    </div>
  );
};

export default PageViewTable;
